var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "search-outside",
      class: {
        bor_radius:
          (_vm.showAssociate && _vm.associateData.length > 0) ||
          _vm.showHistory ||
          _vm.showSearchHeight
      }
    },
    [
      _c("div", { staticClass: "searchNew" }, [
        _c("div", { staticClass: "search-box" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.searchValue,
                expression: "searchValue"
              }
            ],
            staticClass: "search-input",
            class: {
              rightInput: !(
                (_vm.heightSearchObj[_vm.systemId] &&
                  _vm.heightSearchObj[_vm.systemId].searchFormData !== null) ||
                _vm.systemId == "LC_RI"
              )
            },
            attrs: {
              type: "text",
              placeholder: _vm.heightSearchObj[_vm.systemId]
                ? _vm.heightSearchObj[_vm.systemId].placeholder
                : "请输入关键词搜索",
              maxlength: "100"
            },
            domProps: { value: _vm.searchValue },
            on: {
              focus: _vm.searchFocus,
              input: [
                function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.searchValue = $event.target.value
                },
                _vm.searchChange
              ],
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.searchClick(_vm.systemId)
              },
              mouseover: _vm.mouseOver,
              onblur: _vm.searchBlur,
              mouseleave: _vm.mouseLeave
            }
          }),
          _c("span", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.searchValue != "" && _vm.searchValue != undefined,
                expression: "searchValue != '' && searchValue != undefined"
              }
            ],
            staticClass: "el-icon-close closesearch",
            class: {
              rightClass: !(
                (_vm.heightSearchObj[_vm.systemId] &&
                  _vm.heightSearchObj[_vm.systemId].searchFormData !== null) ||
                _vm.systemId == "LC_RI"
              )
            },
            style: _vm.showstyle,
            on: {
              click: _vm.closeClick,
              mouseover: _vm.mouseOver,
              mouseleave: _vm.mouseLeave
            }
          }),
          (_vm.heightSearchObj[_vm.systemId] &&
            _vm.heightSearchObj[_vm.systemId].searchFormData !== null) ||
          _vm.systemId == "LC_RI"
            ? _c(
                "span",
                {
                  staticClass: "search-height",
                  class: { searchheightisclick: _vm.showSearchHeight },
                  on: {
                    click: function($event) {
                      return _vm.showSearchHeightFn(!_vm.showSearchHeight)
                    },
                    mouseenter: function($event) {
                      _vm.showIcon = true
                    },
                    mouseleave: function($event) {
                      _vm.showIcon = false
                    }
                  }
                },
                [
                  _vm._v("高级搜索 "),
                  _vm.showSearchHeight || _vm.showIcon
                    ? _c("senior-icon")
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ]),
        _c("div", { staticClass: "searchNew-right" }, [
          _c("span", { staticClass: "searchNew-right-line" }, [_vm._v("|")]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "searchNew-right-btn",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.searchClick(_vm.systemId)
                }
              }
            },
            [_vm._v("搜索")]
          )
        ])
      ]),
      _c("el-checkbox", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.systemId !== "LCC",
            expression: "systemId !== 'LCC'"
          }
        ],
        staticClass: "firstPage-precise",
        attrs: { label: "精准匹配" },
        model: {
          value: _vm.isPrecise,
          callback: function($$v) {
            _vm.isPrecise = $$v
          },
          expression: "isPrecise"
        }
      }),
      _vm.showHistory
        ? _c(
            "div",
            { staticClass: "search-history" },
            _vm._l(_vm.historyData, function(item, i) {
              return _c(
                "div",
                {
                  key: i,
                  staticClass: "s-h-item",
                  attrs: { title: item.keyWord },
                  on: {
                    mouseover: function($event) {
                      return _vm.itemmouseOver(i)
                    },
                    mouseleave: _vm.itemmouseLeave,
                    click: function($event) {
                      return _vm.chooceHistory(item.keyWord, _vm.systemId)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "s-h-title" }, [
                    _vm._v(_vm._s(item.keyWord))
                  ]),
                  _c(
                    "div",
                    {
                      staticStyle: { color: "#999999", "margin-right": "4px" }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.systemId == ""
                              ? "综合搜索"
                              : _vm.systemList[_vm.systemId]
                          ) +
                          " "
                      )
                    ]
                  ),
                  _c("span", {
                    staticClass: "el-icon-close ",
                    style:
                      i == _vm.mouseIndex
                        ? "color: #C9C9C9;"
                        : "color: #C9C9C9;",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.delHistory(item.keyWord)
                      }
                    }
                  })
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm.showAssociate
        ? _c(
            "div",
            { staticClass: "search-associate" },
            _vm._l(_vm.associateData, function(item, i) {
              return _c(
                "div",
                {
                  key: i,
                  staticClass: "s-a-item",
                  attrs: { title: item.value },
                  on: {
                    click: function($event) {
                      return _vm.chooceAssicuate(item.value, item.systemId)
                    }
                  }
                },
                [
                  _c("div", {
                    staticClass: "line",
                    domProps: { innerHTML: _vm._s(item.highlightValue) }
                  }),
                  _c("div", { staticStyle: { color: "#999999" } }, [
                    _vm._v(" " + _vm._s(_vm.systemList[item.systemId]) + " ")
                  ])
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showSearchHeight && _vm.systemId == "LC_IE",
              expression: "showSearchHeight && systemId == 'LC_IE'"
            }
          ],
          staticClass: "search-height-box",
          staticStyle: { "padding-bottom": "0" },
          on: {
            click: function($event) {
              $event.stopPropagation()
              ;("")
            }
          }
        },
        [
          _c("heightSearchTpl", {
            attrs: { show: _vm.showSearchHeight && _vm.systemId == "LC_IE" }
          })
        ],
        1
      ),
      _vm.showSearchHeight && _vm.systemId == "LC_PUNISH"
        ? _c(
            "div",
            {
              staticClass: "search-height-box",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  ;("")
                }
              }
            },
            [
              _c(
                "el-form",
                {
                  staticClass: "demo-form-inline",
                  attrs: {
                    inline: true,
                    size: "small",
                    model:
                      _vm.heightSearchObj[_vm.systemId].searchFormData.requestVO
                        .filterField,
                    "label-position": "top"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        width: "100%",
                        "justify-content": "space-between",
                        "flex-wrap": "wrap"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "案件名称" } },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              placeholder: "请输入案件名称"
                            },
                            model: {
                              value:
                                _vm.heightSearchObj[_vm.systemId].searchFormData
                                  .requestVO.filterField.title,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.heightSearchObj[_vm.systemId]
                                    .searchFormData.requestVO.filterField,
                                  "title",
                                  $$v
                                )
                              },
                              expression:
                                "heightSearchObj[systemId].searchFormData.requestVO.filterField.title"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "发文案号" } },
                        [
                          _c("el-input", {
                            attrs: {
                              id: "textInput",
                              clearable: "",
                              placeholder: "请输入发文案号"
                            },
                            model: {
                              value:
                                _vm.heightSearchObj[_vm.systemId].searchFormData
                                  .requestVO.filterField.documentNo,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.heightSearchObj[_vm.systemId]
                                    .searchFormData.requestVO.filterField,
                                  "documentNo",
                                  $$v
                                )
                              },
                              expression:
                                "heightSearchObj[systemId].searchFormData.requestVO.filterField.documentNo"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "处罚案由依据" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "224px" },
                            attrs: {
                              clearable: "",
                              placeholder: "请输入处罚案由依据"
                            },
                            model: {
                              value:
                                _vm.heightSearchObj[_vm.systemId].searchFormData
                                  .requestVO.filterField.regTitle,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.heightSearchObj[_vm.systemId]
                                    .searchFormData.requestVO.filterField,
                                  "regTitle",
                                  $$v
                                )
                              },
                              expression:
                                "heightSearchObj[systemId].searchFormData.requestVO.filterField.regTitle"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "处罚对象" } },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              placeholder: "请输入处罚对象"
                            },
                            model: {
                              value:
                                _vm.heightSearchObj[_vm.systemId].searchFormData
                                  .requestVO.filterField.punishmentObject,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.heightSearchObj[_vm.systemId]
                                    .searchFormData.requestVO.filterField,
                                  "punishmentObject",
                                  $$v
                                )
                              },
                              expression:
                                "heightSearchObj[systemId].searchFormData.requestVO.filterField.punishmentObject"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "处罚时间" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              clearable: "",
                              type: "daterange",
                              align: "right",
                              placeholder: "选择日期",
                              "start-placeholder": "开始时间",
                              "end-placeholder": "结束时间",
                              "value-format": "yyyy-MM-dd"
                            },
                            on: { change: _vm.setPublishDate },
                            model: {
                              value:
                                _vm.heightSearchObj[_vm.systemId].searchFormData
                                  .requestVO.filterField.daterange,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.heightSearchObj[_vm.systemId]
                                    .searchFormData.requestVO.filterField,
                                  "daterange",
                                  $$v
                                )
                              },
                              expression:
                                "heightSearchObj[systemId].searchFormData.requestVO.filterField.daterange"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "处罚机关类型" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                multiple: "",
                                placeholder: "请选择处罚机关类型"
                              },
                              on: {
                                change: function($event) {
                                  return _vm.changePubishOrg()
                                }
                              },
                              model: {
                                value:
                                  _vm.heightSearchObj[_vm.systemId]
                                    .searchFormData.requestVO.filterField
                                    .punishOrganCategory,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.heightSearchObj[_vm.systemId]
                                      .searchFormData.requestVO.filterField,
                                    "punishOrganCategory",
                                    $$v
                                  )
                                },
                                expression:
                                  "heightSearchObj[systemId].searchFormData.requestVO.filterField.punishOrganCategory"
                              }
                            },
                            _vm._l(_vm.publishOrgList, function(option) {
                              return _c("el-option", {
                                key: option.id,
                                attrs: {
                                  label: option.punishOrganCategory,
                                  value: option.id
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "执法地域" } },
                        [
                          _c("area-select", {
                            staticClass: "org-select",
                            attrs: {
                              modal: false,
                              multiple: true,
                              placeholder: "请选择执法地域"
                            },
                            model: {
                              value:
                                _vm.heightSearchObj[_vm.systemId].searchFormData
                                  .requestVO.filterField.cityIds,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.heightSearchObj[_vm.systemId]
                                    .searchFormData.requestVO.filterField,
                                  "cityIds",
                                  $$v
                                )
                              },
                              expression:
                                "heightSearchObj[systemId].searchFormData.requestVO.filterField.cityIds"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _c("div", { staticClass: "s-h-bottom" }, [
                _c("input", {
                  staticClass: "btn",
                  attrs: { type: "button", value: "重置" },
                  on: { click: _vm.resetForm }
                }),
                _c("input", {
                  staticClass: "btn btn-red longtitlebtn",
                  attrs: { type: "button", value: "高级搜索" },
                  on: {
                    click: function($event) {
                      return _vm.heightSearch(_vm.systemId)
                    }
                  }
                })
              ])
            ],
            1
          )
        : _vm._e(),
      _vm.showSearchHeight && _vm.systemId == "LC_REGULATORY_TRENDS"
        ? _c(
            "div",
            {
              staticClass: "search-height-box",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  ;("")
                }
              }
            },
            [
              _c(
                "el-form",
                {
                  staticClass: "demo-form-inline",
                  attrs: {
                    inline: true,
                    size: "small",
                    model:
                      _vm.heightSearchObj[_vm.systemId].searchFormData.requestVO
                        .filterField,
                    "label-position": "top"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        width: "100%",
                        "justify-content": "space-between",
                        "flex-wrap": "wrap"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "发文标题" } },
                        [
                          _c("el-input", {
                            staticClass: "publishChannelListSelect",
                            attrs: {
                              id: "textinput",
                              clearable: "",
                              placeholder: "请输入制度标题"
                            },
                            on: {
                              focus: function($event) {
                                return _vm.titlemFocus()
                              },
                              input: function($event) {
                                return _vm.titleChange()
                              }
                            },
                            model: {
                              value:
                                _vm.heightSearchObj[_vm.systemId].searchFormData
                                  .requestVO.filterField.title,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.heightSearchObj[_vm.systemId]
                                    .searchFormData.requestVO.filterField,
                                  "title",
                                  $$v
                                )
                              },
                              expression:
                                "heightSearchObj[systemId].searchFormData.requestVO.filterField.title"
                            }
                          }),
                          _vm.showTitlemAssociateRegulator
                            ? _c(
                                "div",
                                { staticClass: "issueNum-associate" },
                                _vm._l(_vm.titleassociateData, function(
                                  item,
                                  i
                                ) {
                                  return _c(
                                    "div",
                                    {
                                      key: i,
                                      staticClass: "issueNum-item",
                                      attrs: { title: item.title },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.choocetitleAssicuate(
                                            item.title
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("div", {
                                        staticClass: "line",
                                        domProps: {
                                          innerHTML: _vm._s(item.highTitle)
                                        }
                                      })
                                    ]
                                  )
                                }),
                                0
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "发文时间" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              clearable: "",
                              type: "daterange",
                              align: "right",
                              placeholder: "选择日期",
                              "start-placeholder": "开始时间",
                              "end-placeholder": "结束时间",
                              "value-format": "yyyy-MM-dd"
                            },
                            on: { change: _vm.setPublishDate },
                            model: {
                              value:
                                _vm.heightSearchObj[_vm.systemId].searchFormData
                                  .requestVO.filterField.daterange,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.heightSearchObj[_vm.systemId]
                                    .searchFormData.requestVO.filterField,
                                  "daterange",
                                  $$v
                                )
                              },
                              expression:
                                "heightSearchObj[systemId].searchFormData.requestVO.filterField.daterange"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "发文机构" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "publishChannelListSelect",
                              staticStyle: { width: "100%" },
                              attrs: {
                                multiple: "",
                                clearable: "",
                                placeholder: "请选择发文机构"
                              },
                              model: {
                                value:
                                  _vm.heightSearchObj[_vm.systemId]
                                    .searchFormData.requestVO.filterField
                                    .publishOrgId,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.heightSearchObj[_vm.systemId]
                                      .searchFormData.requestVO.filterField,
                                    "publishOrgId",
                                    $$v
                                  )
                                },
                                expression:
                                  "heightSearchObj[systemId].searchFormData.requestVO.filterField.publishOrgId"
                              }
                            },
                            _vm._l(_vm.publishChannelList, function(item) {
                              return _c("el-option", {
                                key: item.publishOrgId,
                                attrs: {
                                  label: item.publishOrgName,
                                  value: item.publishOrgId
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _c("div", { staticClass: "s-h-bottom" }, [
                _c("input", {
                  staticClass: "btn",
                  attrs: { type: "button", value: "重置" },
                  on: { click: _vm.resetForm }
                }),
                _c("input", {
                  staticClass: "btn btn-red longtitlebtn",
                  attrs: { type: "button", value: "高级搜索" },
                  on: {
                    click: function($event) {
                      return _vm.heightSearch(_vm.systemId)
                    }
                  }
                })
              ])
            ],
            1
          )
        : _vm._e(),
      _vm.showSearchHeight && _vm.systemId == "LCC"
        ? _c(
            "div",
            {
              staticClass: "search-height-box",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  ;("")
                }
              }
            },
            [
              _c(
                "el-form",
                {
                  staticClass: "demo-form-inline",
                  attrs: {
                    inline: true,
                    size: "small",
                    model:
                      _vm.heightSearchObj[_vm.systemId].searchFormData.requestVO
                        .searchFields,
                    "label-position": "top"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        width: "100%",
                        "justify-content": "space-between",
                        "flex-wrap": "wrap"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "合同名称" } },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              placeholder: "请输入合同名称"
                            },
                            model: {
                              value:
                                _vm.heightSearchObj[_vm.systemId].searchFormData
                                  .requestVO.searchFields.contractTitle,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.heightSearchObj[_vm.systemId]
                                    .searchFormData.requestVO.searchFields,
                                  "contractTitle",
                                  $$v
                                )
                              },
                              expression:
                                "heightSearchObj[systemId].searchFormData.requestVO.searchFields.contractTitle"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "制度标题" } },
                        [
                          _c("el-input", {
                            attrs: {
                              id: "textinput",
                              clearable: "",
                              placeholder: "请输入制度标题"
                            },
                            on: {
                              focus: function($event) {
                                return _vm.titlemFocus()
                              },
                              input: function($event) {
                                return _vm.titleChange()
                              }
                            },
                            model: {
                              value:
                                _vm.heightSearchObj[_vm.systemId].searchFormData
                                  .requestVO.searchFields.instTitle,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.heightSearchObj[_vm.systemId]
                                    .searchFormData.requestVO.searchFields,
                                  "instTitle",
                                  $$v
                                )
                              },
                              expression:
                                "heightSearchObj[systemId].searchFormData.requestVO.searchFields.instTitle"
                            }
                          }),
                          _vm.showtitlemAssociate
                            ? _c(
                                "div",
                                { staticClass: "issueNum-associate" },
                                _vm._l(_vm.titleassociateData, function(
                                  item,
                                  i
                                ) {
                                  return _c(
                                    "div",
                                    {
                                      key: i,
                                      staticClass: "issueNum-item",
                                      attrs: { title: item.value },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.choocetitleAssicuate(
                                            item.value
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("div", {
                                        staticClass: "line",
                                        domProps: {
                                          innerHTML: _vm._s(item.highlightValue)
                                        }
                                      })
                                    ]
                                  )
                                }),
                                0
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "制度文号" } },
                        [
                          _c("el-input", {
                            attrs: {
                              id: "textinput",
                              clearable: "",
                              placeholder: "请输入制度文号"
                            },
                            on: {
                              focus: function($event) {
                                return _vm.instIssueNumFocus()
                              },
                              input: function($event) {
                                return _vm.instIssueNumChange()
                              }
                            },
                            model: {
                              value:
                                _vm.heightSearchObj[_vm.systemId].searchFormData
                                  .requestVO.searchFields.instIssueNum,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.heightSearchObj[_vm.systemId]
                                    .searchFormData.requestVO.searchFields,
                                  "instIssueNum",
                                  $$v
                                )
                              },
                              expression:
                                "heightSearchObj[systemId].searchFormData.requestVO.searchFields.instIssueNum"
                            }
                          }),
                          _vm.showinstIssueNumAssociate
                            ? _c(
                                "div",
                                { staticClass: "issueNum-associate" },
                                _vm._l(_vm.instIssueNumassociateData, function(
                                  item,
                                  i
                                ) {
                                  return _c(
                                    "div",
                                    {
                                      key: i,
                                      staticClass: "issueNum-item",
                                      attrs: { title: item.value },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.chooceinstIssueNumAssicuate(
                                            item.value
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("div", {
                                        staticClass: "line",
                                        domProps: {
                                          innerHTML: _vm._s(item.highlightValue)
                                        }
                                      })
                                    ]
                                  )
                                }),
                                0
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "拟稿部门" } },
                        [
                          _c("org-select", {
                            staticClass: "org-select",
                            attrs: {
                              modal: false,
                              multiple: true,
                              placeholder: "请选择拟稿部门"
                            },
                            model: {
                              value:
                                _vm.heightSearchObj[_vm.systemId].searchFormData
                                  .requestVO.searchFields.publishOrg2,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.heightSearchObj[_vm.systemId]
                                    .searchFormData.requestVO.searchFields,
                                  "publishOrg2",
                                  $$v
                                )
                              },
                              expression:
                                "heightSearchObj[systemId].searchFormData.requestVO.searchFields.publishOrg2"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "合同业务分类" } },
                        [
                          _c("my-cascader", {
                            attrs: {
                              placeholder: "请选择合同业务分类",
                              options: _vm.businessTypeOptions,
                              props: {
                                multiple: true,
                                value: "key",
                                label: "title"
                              },
                              clearable: ""
                            },
                            model: {
                              value:
                                _vm.heightSearchObj[_vm.systemId].searchFormData
                                  .requestVO.searchFields.businessType2,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.heightSearchObj[_vm.systemId]
                                    .searchFormData.requestVO.searchFields,
                                  "businessType2",
                                  $$v
                                )
                              },
                              expression:
                                "heightSearchObj[systemId].searchFormData.requestVO.searchFields.businessType2"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "版本状态" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "请选择版本状态",
                                multiple: "",
                                clearable: ""
                              },
                              model: {
                                value:
                                  _vm.heightSearchObj[_vm.systemId]
                                    .searchFormData.requestVO.searchFields
                                    .status,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.heightSearchObj[_vm.systemId]
                                      .searchFormData.requestVO.searchFields,
                                    "status",
                                    $$v
                                  )
                                },
                                expression:
                                  "heightSearchObj[systemId].searchFormData.requestVO.searchFields.status"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "有效", value: "VALID" }
                              }),
                              _c("el-option", {
                                attrs: { label: "废止", value: "INVALID" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "启用日期" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              clearable: "",
                              type: "daterange",
                              align: "right",
                              placeholder: "选择日期",
                              "start-placeholder": "开始日期",
                              "end-placeholder": "结束日期",
                              "value-format": "yyyy-MM-dd"
                            },
                            on: { change: _vm.setPublishDate },
                            model: {
                              value:
                                _vm.heightSearchObj[_vm.systemId].searchFormData
                                  .requestVO.searchFields.effectRange,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.heightSearchObj[_vm.systemId]
                                    .searchFormData.requestVO.searchFields,
                                  "effectRange",
                                  $$v
                                )
                              },
                              expression:
                                "heightSearchObj[systemId].searchFormData.requestVO.searchFields.effectRange"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "废止日期" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              clearable: "",
                              type: "daterange",
                              align: "right",
                              placeholder: "选择日期",
                              "start-placeholder": "开始日期",
                              "end-placeholder": "结束日期",
                              "value-format": "yyyy-MM-dd"
                            },
                            on: { change: _vm.setPublishDate },
                            model: {
                              value:
                                _vm.heightSearchObj[_vm.systemId].searchFormData
                                  .requestVO.searchFields.expireRange,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.heightSearchObj[_vm.systemId]
                                    .searchFormData.requestVO.searchFields,
                                  "expireRange",
                                  $$v
                                )
                              },
                              expression:
                                "heightSearchObj[systemId].searchFormData.requestVO.searchFields.expireRange"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _c("div", { staticClass: "s-h-bottom" }, [
                _c("input", {
                  staticClass: "btn",
                  attrs: { type: "button", value: "重置" },
                  on: { click: _vm.resetForm }
                }),
                _c("input", {
                  staticClass: "btn btn-red longtitlebtn",
                  attrs: { type: "button", value: "高级搜索" },
                  on: {
                    click: function($event) {
                      return _vm.heightSearch(_vm.systemId)
                    }
                  }
                })
              ])
            ],
            1
          )
        : _vm._e(),
      _vm.systemBaseUrl["LC_RI"]
        ? _c("div", [
            _c("iframe", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showSearchHeight && _vm.systemId == "LC_RI",
                  expression: "showSearchHeight && systemId == 'LC_RI'"
                }
              ],
              ref: "iframe",
              staticClass: "search-height-box",
              staticStyle: {
                padding: "0",
                overflow: "auto",
                height: "508px!important"
              },
              attrs: {
                id: "authIframe",
                src: _vm.systemBaseUrl["LC_RI"] + "/heightSearchReg",
                scrolling: "no",
                frameborder: "0"
              }
            })
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }